import {
    sessionService,
    SessionManager,
    //scrapeService,
    ApiManager,
    SignalRScrapeService,
    UtilityLibrary,
    LoggerUtility,
    EnumUtility,
    ClientType,
    ErrorModel
} from '../components/ComponentsLibrary';
import MockResponseUtility from './MockMainframeResponse';
import { ApiEndpoints, default as ApiKeyManager } from "./ApiConfig";

const GetCaseDataFromScrape = async (paramsForRequest) => {
    try {
        const propsForService = {
            //apiMainframeUrl: "https://localhost:7089/api/",
            apiMainframeUrl: paramsForRequest.apiMainframeUrl,
        };
        const signalRService = new SignalRScrapeService(propsForService);

        try {

            let responseScrapedData;

            // 🔍 ADDED: Check for specific date and user
            const today = new Date();
            const todayString = today.getFullYear().toString() + 
                   (today.getMonth() + 1).toString().padStart(2, '0') + 
                   today.getDate().toString().padStart(2, '0');


            const loginUserInfo = sessionService.getUser();
            const currentUserID = loginUserInfo ? loginUserInfo.userInfoID : null;

            if (UtilityLibrary.isUsingMockData()) {
                const caseNumber = paramsForRequest.requestJSON?.CaseNumber;
                responseScrapedData = MockResponseUtility.getMockResponseForCaseNumber(caseNumber);
            } else {
                // 🔍 Normal SignalR request for all other cases
                responseScrapedData = await signalRService.submitRequest(paramsForRequest);
            }
            
            if (responseScrapedData.ErrorCode === EnumUtility.CaseSearchResultCode.ScraperSessionError.Name) {
                throw new ErrorModel(responseScrapedData?.Message,
                    'SignalRScrapeService.SubmitRequest',
                    { type: EnumUtility.CaseSearchResultCode.MFSessionDisconnectError.Name } // overwrite becuause it will have same message as mainframesessiondisconnected
                ); 
            } else if (responseScrapedData.ErrorCode === EnumUtility.CaseSearchResultCode.Enter_A_Function_Error.Name) {
                throw new ErrorModel(responseScrapedData?.Message,
                    'SignalRScrapeService.SubmitRequest',
                    { type: EnumUtility.CaseSearchResultCode.Enter_A_Function_Error.Name } 
                );
            }
            
            if (paramsForRequest.blockID != 45 && paramsForRequest.blockID != 71) {   // 45 and 71 are Go Home Blocks.

                // Parse CP Name if it exists
                if (responseScrapedData && responseScrapedData.CPName) {
                    const parsedCPName = UtilityLibrary.parseFullName(responseScrapedData.CPName);
                    responseScrapedData.CPFirstName = parsedCPName.firstName;
                    responseScrapedData.CPLastName = parsedCPName.lastName;
                }

                // Parse NCP Name if it exists
                if (responseScrapedData && responseScrapedData.NCPName) {
                    const parsedNCPName = UtilityLibrary.parseFullName(responseScrapedData.NCPName);
                    responseScrapedData.NCPFirstName = parsedNCPName.firstName;
                    responseScrapedData.NCPLastName = parsedNCPName.lastName;
                }

                const loginUserInfo = sessionService.getUser();
                const stateID = loginUserInfo ? loginUserInfo.stateID : -1;

                //call api endpoint to get message content and compare message content with the fvi field in caseData
                const confidentialCase = await ApiManager.getMessageContent({
                    messageContentID: ClientType.MessageContent.V_DV3537_CONFIDENTIAL_CASE_DATA,
                    stateID
                })
                const fviAndConfidentialCase = await ApiManager.getMessageContent({
                    messageContentID: ClientType.MessageContent.V_DV3538_FVI_And_CONFIDENTIALCASE_DATA,
                    stateID
                })

                // Determine values for responseScrapedData.ConfidentialCase and responseScrapedData.FamilyViolence.
                // Check for confidential case (Mississippi only)
                // Determine if case is restricted confidential for THIS USER. Some users can see confidential cases in METSS and some cannot.
                if (stateID === EnumUtility.StateIDKey.Mississippi.ID) {
                    const caseNum = String(responseScrapedData.CaseNumber).toUpperCase(); 
                    SessionManager.SetSession(`confidentialCaseUser_${caseNum}`, false); // Default to false, will update to true if we find a match in the messages
                    if (responseScrapedData.FVIAndConfidentialCase) {
                        const fviAndConfidentialText = responseScrapedData.FVIAndConfidentialCase.trim();
                        
                        // Rule 3 & 4: Check if it matches confidential case message
                        if (fviAndConfidentialText === confidentialCase?.[0]?.messageText?.trim()) {
                            responseScrapedData.ConfidentialCase = "Y";
                            // User is not allowed to see this case because it is confidential. Save in SessionStorage.
                            SessionManager.SetSession(`confidentialCaseUser_${caseNum}`, true);
                        }
                        
                        // Rule 6: Check if it matches FVI+Confidential case message (also sets confidential)
                        if (fviAndConfidentialText === fviAndConfidentialCase?.[0]?.messageText?.trim()) {
                            responseScrapedData.ConfidentialCase = "Y";
                            // User is not allowed to see this case because it is confidential. Save in SessionStorage.
                            SessionManager.SetSession(`confidentialCaseUser_${caseNum}`, true);
                        }
                    }
                }

                // Check for family violence case 

                // Only update if FamilyViolence doesn't already have a value (rule #9)
                if (!responseScrapedData.FamilyViolence || responseScrapedData.FamilyViolence.trim() === "") {
                    if (responseScrapedData.FVIAndConfidentialCase && 
                        responseScrapedData.FVIAndConfidentialCase.trim() === fviAndConfidentialCase?.[0]?.messageText?.trim()) {
                        responseScrapedData.FamilyViolence = "Y";
                    }
                }
                
                
                if (stateID === EnumUtility.StateIDKey.Mississippi.ID) {
                    if (!responseScrapedData.ConfidentialCase || responseScrapedData.ConfidentialCase !== "Y") {
                        responseScrapedData.ConfidentialCase = "_";
                    }
                    
                    if (!responseScrapedData.FamilyViolence || responseScrapedData.FamilyViolence === "") {
                        responseScrapedData.FamilyViolence = "_";
                    }
                }

                let isCaseFound = false;
                if (responseScrapedData) {
                    isCaseFound = responseScrapedData.CaseFound === '' ? true : false;
                }
                
                if (isCaseFound) {

                    // const apiResponse = await ApiManager.PostCaseDataFromScrapeToApi(responseScrapedData);
                    // apiResponse.caseInfo = responseScrapedData
                    // console.log(apiResponse);
                    return {//Temp added just to check
                        caseInfo: responseScrapedData,
                        statusCode: 100,
                        errorMessage: ""
                    };

                }
                else {
                    const loginUserInfo = sessionService.getUser();
                    const userStateID = loginUserInfo ? loginUserInfo.stateID : -1;
                    const caseNotFoundError = EnumUtility.getCaseNumberNotFoundError(userStateID);

                    const caseInfoObj = {
                        caseInfo: {},
                        statusCode: EnumUtility.CaseSearchResultCode.CaseNotFound.ID,
                        errorMessage: caseNotFoundError || {}, // Return empty object if user not in allowed states
                    };
                    return caseInfoObj;
                }

            } else {
                return responseScrapedData;
            }



        } finally {
            await signalRService.stopConnection();
        }
    }
    catch (error) {
        const errorType = error?.Details?.type;
        if ([
            EnumUtility.CaseSearchResultCode.MFSessionDisconnectError.Name,
            EnumUtility.CaseSearchResultCode.ScraperDisconnectedError.Name,
            EnumUtility.CaseSearchResultCode.Enter_A_Function_Error.Name].includes(errorType)) {
            throw error
        }
        else {
            throw LoggerUtility.ProcessErrorData(error, "GetCaseDataFromScrape", {});
        }
    }
};


const PushDataToScrape = async (paramsForRequest) => {
    try {
        const propsForService = {
            //apiMainframeUrl: "https://localhost:7089/api/",
            apiMainframeUrl: paramsForRequest.apiMainframeUrl,
        };

        const signalRService = new SignalRScrapeService(propsForService);

        let response;


        try {

            if (UtilityLibrary.isUsingMockData()) {
                const caseNumber = paramsForRequest.requestJSON?.CaseNumber;
                response = MockResponseUtility.getMockResponseForNarrativePush(caseNumber);
            } else {
                response = await signalRService.submitRequest(paramsForRequest);
            }

            console.log(response);
            return response;
            
        } finally {
            await signalRService.stopConnection();
        }
    }
    catch (error) {
        const errorType = error?.Details?.type;
        if ([
            EnumUtility.CaseSearchResultCode.MFSessionDisconnectError.Name,
            EnumUtility.CaseSearchResultCode.ScraperDisconnectedError.Name].includes(errorType)) {
            throw error
        }
        else {
            throw LoggerUtility.ProcessErrorData(error, "PushDataToScrape", {});
        }
    }
};


const PushNarrativeToMainframe = async (paramsObj) => {
    try {
        if (paramsObj.stateID === EnumUtility.StateIDKey.Kansas.ID) {
            const paramsForRequest = {
                apiMainframeUrl: paramsObj.apiMainframeUrl,
                blockID: EnumUtility.MainframePushBlockID.KansasNarrativeSave.ID,
                requestJSON: {
                    CaseNumber: paramsObj.caseNumber,
                    MainframeNarrative: paramsObj.narrativeText,
                }
            };
            return await PushDataToScrape(paramsForRequest);
        }
        else if (paramsObj.stateID === EnumUtility.StateIDKey.Mississippi.ID) {
            const paramsForRequest = {
                apiMainframeUrl: paramsObj.apiMainframeUrl,
                blockID: EnumUtility.MainframePushBlockID.MississippiNarrativeSave.ID,
                requestJSON: {
                    CaseNumber: paramsObj.caseNumber,
                    MainframeNarrative: paramsObj.narrativeText,
                }
            };
            return await PushDataToScrape(paramsForRequest);
        }
    }
    catch (error) {
        const errorType = error?.Details?.type;
        if ([
            EnumUtility.CaseSearchResultCode.MFSessionDisconnectError.Name,
            EnumUtility.CaseSearchResultCode.ScraperDisconnectedError.Name].includes(errorType)) {
            throw error
        }
        else {
            throw LoggerUtility.ProcessErrorData(error, "PushNarrativeToMainframe", {});
        }
    }
};


const ScrapeDataManager = {

    GetCaseDataFromScrape,
    PushDataToScrape,
    PushNarrativeToMainframe,
};


export default ScrapeDataManager;